import {Component, Input, OnInit} from '@angular/core';
import {ComponentHelper, FormBaseComponent, NavigationService, ValidatorService} from '@utils-lib';
import {AppNameEnum, JuristischePerson} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-juristische-person',
    templateUrl: './juristische-person.component.html',
    styleUrls: ['./juristische-person.component.scss']
})
export class JuristischePersonComponent extends FormBaseComponent<JuristischePerson> implements OnInit{

    @Input()
    public affectNavigationInfo = false;
    @Input()
    public stammdatenFirmenname: JuristischePerson;
    public isKapgOrKapgaus = false;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly activatedRoute: ActivatedRoute,
                private readonly validatorService: ValidatorService,
                protected readonly messageService: DatevMessageService,
                public readonly navigationService: NavigationService) {
        super(messageService);
    }

  public ngOnInit(): void {
    super.ngOnInit();
    let appName = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
    this.isKapgOrKapgaus = (appName === AppNameEnum.FragebogenKapG || appName === AppNameEnum.FragebogenKapGAus);
    this.onNameChange();
  }

    public onNameChange(): void {
        if (this.affectNavigationInfo) {
            this.navigationService.onMandantNameUpdated(this.data.firmenname, null);
        }
    }

    public onFirmaPicked($event: unknown): void {
        this.form.get('firmenname').setValue($event);
        this.onNameChange();
    }

    protected createForm(): void {
      const minLength = 1;
      const maxLength = 120;
      this.form = this.formBuilder.group({
            firmenname: [this.data.firmenname, [
                this.validatorService.required(),
                this.validatorService.minLength(minLength),
                this.validatorService.maxLength(maxLength)
            ]]
        });
    }
}
